import { useContext } from 'react';
import card from '../docs/light/card.png';
import '../style/components/getAccess.css'
import { switchh } from '../context/switch';
import { context } from '../context/context';

export default function GetAccess () {
    const { setAccess, setEnableReturns, initialReturn } = useContext(switchh);
    const {setCart} = useContext(context);
    return (
        <div className="access-container container-box fixed flex flex-center-center">
            <div className="box center">
             <button onClick={() => {
                    setEnableReturns(initialReturn);
                    setCart([])
                    setAccess(false); 
                }} className='close'>x</button>
                <h2>مرر الكارت <span><img width={20} src={card} /></span></h2>
                <p>اطلب من المدير الصلاحية</p>
            </div>
        </div>
    )
}